import { FpLoggerNoiseTabs } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/enums/fp-logger-noise-tabs.enum';
import { IFpLoggerNoiseData } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/interfaces/fp-logger-noise-data';

export interface IFpLoggerNoiseSummaryState {
  currentTab: FpLoggerNoiseTabs.Summary;
  date: string | null;
  data: IFpLoggerNoiseData | null;
  loading: boolean;
}

export const initialFpLoggerNoiseSummaryState: IFpLoggerNoiseSummaryState = {
  currentTab: FpLoggerNoiseTabs.Summary,
  date: null,
  data: null,
  loading: false,
};
